import FlashLib from "flashlib";
import EntryPoint from "Engine/EntryPoint";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import * as PIXI from "pixi.js";
import SoundManager from "Engine/soundManager/SoundManager";
import MoneyFormat from "Base/MoneyFormat";
import Animation from "Engine/base/animation/Animation";
import {TweenMax, Linear} from "gsap";
import GameModel from "../model/GameModel";

export default class BigWinContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.valueText = null;
        this.interactive = true;
        //this.buttonMode = true;
        this.texValue = {
            value: 0,
            state: 1,
            totalValue: 0
        };

        this.init();
        this.addListeners();
        this.createTweens();
        this.hide();
    }

    init() {
        //15 25 50

        this.y = EntryPoint.Game.gameSize.height / 2;

        this.bigWinBg = new Animation('big_win_bg_spine');
        this.bigWinBg.y = 70;
        this.bigWinBg.on('complete', () => {
            this.bigWinBg.play(true, 'BG_Idle');
        });

        this.bigWinText = new Animation('big_win_text_spine');
        this.bigWinText.y = 70;
        this.bigWinText.on('complete', () => {
            switch (this.bigWinText.animationName) {
                case 'BigWin_In':
                    this.bigWinText.play(true, 'BigWin_Idle');
                    break;
                case 'MegaWin_In':
                    this.bigWinText.play(true, 'MegaWin_Idle');
                    break;
                case 'SuperMegaWin_In':
                    this.bigWinText.play(true, 'SuperMegaWin_Idle');
                    break;
            }
        });

        this.bigWinCounter = new Animation('big_win_counter_spine');
        this.bigWinCounter.y = 70;
        this.bigWinCounter.on('complete', () => {
            this.bigWinCounter.play(true, 'Counter_Idle');
        });

        this.addChild(this.bigWinBg);
        this.addChild(this.bigWinText);
        this.addChild(this.bigWinCounter);

        //this.valueText = this.getChildByName('valueText');

        this.valueText = new PIXI.BitmapText('1234567890.,', {
            font: {name: 'winningFont', size: '120px'},
            align: 'center'
        });
        this.valueText.anchor.set(0.5, 0.5);
        this.valueText.y = 170;
        let sss = this.getChildByName('valueText');
        sss.destroy();
        this.addChild(this.valueText);
    }

    addListeners() {
        GlobalDispatcher.add('stateEnd:showBigWinState', this.complete, this);
        GlobalDispatcher.add('stateStart:showBigWinState', this.show, this);
        this.on('pointertap', () => {
            this.fastStop();
        });
    }

    createTweens() {
        this.counterTween = TweenMax.fromTo(this.valueText.scale, 0.15, {x: 1, y: 1}, {
            x: 1.7,
            y: 1.7,
            repeat: 1,
            yoyo: true,
            ease: Linear.easeNone,
            paused: true
        });
    }

    fastStop() {
        SoundManager.stop(this.backgroundSoundName);
        SoundManager.stop('sounds/mainGame/BigWinCounter');

        TweenMax.killTweensOf(this.texValue);
        this.texValue.state = this.getType(this.texValue.totalValue);
        this.texValue.value = this.texValue.totalValue;
        this.onValueComplete();
    }

    show() {
        this.interactive = true;
        this.texValue.state = 1;
        this.texValue.totalValue = EntryPoint.GameModel.totalWin;

        this.bigWinBg.play(false, 'BG_In');
        this.bigWinText.play(false, 'BigWin_In');
        this.bigWinCounter.play(false, 'Counter_In');

        let type = this.getType(this.texValue.totalValue);
        this.playBackgroundSound(type);

        let time = type * 4;
        TweenMax.fromTo(this.texValue, time, {value: 0}, {
            value: this.texValue.totalValue,
            ease: Linear.easeNone,
            onStart: this.onValueStart,
            onUpdate: this.onValueUpdate,
            onComplete: this.onValueComplete,
            callbackScope: this
        });

        this.valueText.text = MoneyFormat.format(this.texValue.value);
        this.visible = true;
        GlobalDispatcher.dispatch('overlay:show');
    }

    playBackgroundSound(type) {
        let soundName = '';
        switch (type) {
            case 1:
                soundName = 'BigWin';
                break;
            case 2:
                soundName = 'MegaWin';
                break;
            case 3:
                soundName = 'SuperMegaWin';
                break;
        }
        this.backgroundSoundName = 'sounds/mainGame/' + soundName;
        //console.log('BigWinSoundName', this.backgroundSoundName);
        SoundManager.play(this.backgroundSoundName, 1, false);
    }

    onValueStart() {
        SoundManager.play('sounds/mainGame/BigWinCounter', 1, true);
    }

    onValueUpdate() {
        this.valueText.text = MoneyFormat.format(this.texValue.value, false);
        if (this.texValue.state === 2 && this.getType(this.texValue.value) === 3) {
            this.bigWinText.stop();
            this.bigWinText.play(false, 'SuperMegaWin_In');
            this.texValue.state = 3;
            this.counterTween.play(0);
        }
        if (this.texValue.state === 1 && this.getType(this.texValue.value) === 2) {
            this.bigWinText.stop();
            this.bigWinText.play(false, 'MegaWin_In');
            this.texValue.state = 2;
            this.counterTween.play(0);
        }
    }

    getType(value) {
        let type = 1;
        if (value >= EntryPoint.GameModel.totalBet * 50) {
            type = 3;
        } else if (value >= EntryPoint.GameModel.totalBet * 25) {
            type = 2;
        }
        return type;
    }

    onValueComplete() {
        this.interactive = false;
        this.valueText.text = MoneyFormat.format(this.texValue.value, false);
        let animationName = null;
        switch (this.texValue.state) {
            case 1:
                animationName = 'BigWin_Out';
                break;
            case 2:
                animationName = 'MegaWin_Out';
                break;
            case 3:
                animationName = 'SuperMegaWin_Out';
                break;
        }
        if (animationName) {
            this.bigWinText.play(false, animationName);
            this.counterTween.play(0);
        }
        setTimeout(() => {
            GlobalDispatcher.dispatch('bigWinContainer:stopState');
        }, 2000);

        SoundManager.stop('sounds/mainGame/BigWinCounter');
    }

    hide() {
        this.bigWinBg.stop();
        this.bigWinText.stop();
        this.bigWinCounter.stop();
        this.visible = false;
        GlobalDispatcher.dispatch('overlay:hide');
    }

    complete() {
        this.hide();
    }
}